function reportToDataDog(
    error: Error | string,
    context: { [key: string]: any }
) {
    const datadog =
        typeof window !== 'undefined'
            ? (window as any).DD_RUM
            : // eslint-disable-next-line no-restricted-globals -- deliberate typeof-guarded SSR env detection
            typeof global !== 'undefined'
            ? // eslint-disable-next-line no-restricted-globals -- deliberate typeof-guarded SSR env detection
              (global as any).DD_RUM
            : undefined;

    if (!datadog || !datadog.addError) {
        return false;
    }
    datadog.addError(error, context);

    return true;
}

export function trackError(
    error: Error | string,
    context: { [key: string]: any } = {}
) {
    const didReport = reportToDataDog(error, context);
    if (didReport) {
        return;
    }

    // eslint-disable-next-line no-console
    console.error(error, context);
}
